export default "__VITE_ASSET__BkI_K_YR__"